import * as React from "react";
import { LocalizedType } from "../types/Types";
import _ from "lodash";
import { Helmet } from "react-helmet";

interface LinkAlternateLocalizedProps {
  localized: LocalizedType[];
  currentUrl: string;
  language: string;
}

const LANGUAGE_HREFLANGS: Record<string, string> = {
  de: "de-CH",
  fr: "fr-CH",
  it: "it-CH",
  en: "en-CH",
};

const cleanUrl = (url: string | null | undefined): string => {
  if (!url) return "";
  return url.includes("/__home__") ? url.replace("/__home__", "") : url;
};

const LinkAlternateLocalized: React.FC<LinkAlternateLocalizedProps> = ({
  localized,
  currentUrl,
  language,
}) => {
  const currentCleanUrl = cleanUrl(currentUrl);

  if (!currentCleanUrl) {
    return null;
  }

  const defaultLang = "de";
  const defaultEntry = _.find(localized, { language: defaultLang });
  const defaultUrl = cleanUrl(defaultEntry?.url) || currentCleanUrl;

  return (
    <Helmet>
      <link rel="canonical" href={currentCleanUrl} />
      {Object.entries(LANGUAGE_HREFLANGS).map(([lang, hrefLang]) => {
        const entry = _.find(localized, { language: lang });
        const url = lang === language ? currentCleanUrl : cleanUrl(entry?.url);
        return url ? (
          <link key={lang} rel="alternate" hrefLang={hrefLang} href={url} />
        ) : null;
      })}
      <link rel="alternate" hrefLang="x-default" href={defaultUrl} />
    </Helmet>
  );
};

export default LinkAlternateLocalized;
